<template>
  <RModal
    ref="modal"
    title="Create new subject category"
    :persistent="false"
    @cancel="modalShow = false"
    @hide="modalShow = false"
    @ok="save"
  >
    <RInput
      v-model.trim="subjectCategory"
      autofocus
      class="q-pt-lg"
      label="Subject category"
      no-hint
      no-feedback-icon
      @keyup.enter="save"
    />
  </RModal>
</template>

<script>
// Components
import RModal from '@/ui/RModal'

export default {
  components: {
    RModal
  },

  props: {
    value: {
      type: Boolean,
      required: true
    }
  },

  data: () => ({
    subjectCategory: ''
  }),

  computed: {
    modalShow: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('input', newVal)
      }
    }
  },

  watch: {
    modalShow(newVal) {
      if (newVal) this.$refs.modal.show()
      else this.$refs.modal.hide()
    }
  },

  methods: {
    save() {
      if (!this.subjectCategory.trim()) return
      this.$emit('save', this.subjectCategory)
      this.subjectCategory = ''
      this.modalShow = false
    }
  }
}
</script>
